// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-basis[data-v-5f07dc67] {\n  -ms-flex-preferred-size: 33%;\n      flex-basis: 33%;\n}\n", ""]);
// Exports
module.exports = exports;
